module.exports = __webpack_public_path__ + "img/image03.89db4954.jpg";